import React, {  useEffect } from 'react';
import Thumbnail from '../Thumbnail';
import DotIcon from '../DotIcon';

const Carousel = ({ children, time }) => {
  const [index, setIndex] = React.useState(0);
  const items = React.Children.toArray(children);
  const keys = items.map((_, idx) => idx);

  useEffect(() => {
    if (keys.length === 0) return undefined;
    const interval = setInterval(() => {
      setIndex((current) => (current + 1) % keys.length);
    }, time);
    return () => clearInterval(interval);
  }, [keys.length, time]);
  
  const _slides = () => {
    return items.map((child, idx) => (
      <Thumbnail key={idx} id={idx} selectedKey={index}>
        {child}
      </Thumbnail>
    ));
  }

  const _sliderDots = () => {
    return keys.map(key => (
      <span key={key} onClick={() => setIndex(key)}>
        {<DotIcon selected={key === index} />}
      </span>
    ));
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-center w-full my-3">
      <div className="grid grid-flow-row auto-rows-max">
        <div className="min-h-300">
          { _slides() }
        </div>
        <div className="flex justify-center mt-2">
          { _sliderDots() }
        </div>
      </div>
    </div>
  );
}

export default Carousel;